export default __webpack_public_path__ + "static/lalibrairie-j-mobile-7fccb083c11d031579150c61c0eeca9e.jpg";